import React from "react";
import { Link } from "react-router-dom";
import { FaPhone, FaFacebook, FaInstagram, FaYoutube, FaTwitter, FaTiktok, FaEnvelope } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-[#0072bc] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4 max-w-6xl mx-auto">
          <div>
            <h3 className="mb-4 text-lg font-bold">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services/ac-services" className="hover:underline">
                  AC Services
                </Link>
              </li>
              <li>
                <Link to="/services/carpenter-services" className="hover:underline">
                  Carpenter Services
                </Link>
              </li>
              <li>
                <Link to="/services/electrician-services" className="hover:underline">
                  Electrician Services
                </Link>
              </li>
              <li>
                <Link to="/services/handyman-services" className="hover:underline">
                  Handyman Services
                </Link>
              </li>
              <li>
                <Link to="/services/painter-services" className="hover:underline">
                  Painter Services
                </Link>
              </li>
              <li>
                <Link to="/services/plumber-services" className="hover:underline">
                  Plumber Services
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-lg font-bold">Available In</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/locations/lahore" className="hover:underline">
                  Lahore
                </Link>
              </li>
              <li>
                <Link to="/locations/karachi" className="hover:underline">
                  Karachi
                </Link>
              </li>
              <li>
                <Link to="/locations/islamabad" className="hover:underline">
                  Islamabad
                </Link>
              </li>
              <li>
                <Link to="/locations/rawalpindi" className="hover:underline">
                  Rawalpindi
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-lg font-bold">Main Menu</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:underline">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about-us" className="hover:underline">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact-us" className="hover:underline">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/faqs" className="hover:underline">
                  FAQs
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-lg font-bold">Connect with us</h3>
            <ul className="space-y-2">
              <li className="flex items-center">
                <FaPhone className="mr-2 h-4 w-4" />
                <a href="tel:+1234567890" className="hover:underline">
                  +123 456 7890
                </a>
              </li>
              <li className="flex items-center">
                <FaEnvelope className="mr-2 h-4 w-4" />
                <a href="mailto:info@example.com" className="hover:underline">
                  hazer@example.com
                </a>
              </li>
            </ul>

            {/* Social Media Icons */}
            <div className="flex space-x-4 mt-4">
              <a href="#" className="hover:opacity-80">
                <FaFacebook className="h-6 w-6" />
              </a>
              <a href="#" className="hover:opacity-80">
                <FaInstagram className="h-6 w-6" />
              </a>
              <a href="#" className="hover:opacity-80">
                <FaYoutube className="h-6 w-6" />
              </a>
              <a href="#" className="hover:opacity-80">
                <FaTwitter className="h-6 w-6" />
              </a>
              <a href="#" className="hover:opacity-80">
                <FaTiktok className="h-6 w-6" />
              </a>
            </div>

          </div>
        </div>

        <div className="border-t border-gray-300 opacity-50 mt-8"></div>

        {/* Copyright section */}
        <div className="mt-4 text-center text-sm max-w-6xl mx-auto">
          <p>© Copyright 2023 All Rights Reserved | Hazer Global</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
